import React from 'react'
import Slider from 'react-slick'
import Headline from '../atoms/Headline'
import Image from '../atoms/Image'
import Link from '../atoms/Link'
import SbEditable from 'storyblok-react'

// TODO: headline kicker root.name? + fade-in on image

const AcademyCourseBlock = ({ block }) => {
  function NextArrow(props) {
    const { className, onClick } = props
    return (
      <span className={className} onClick={onClick}>
        <i className="fal fa-chevron-right"></i>
      </span>
    )
  }

  function PrevArrow(props) {
    const { className, onClick } = props
    return (
      <span className={className} onClick={onClick}>
        <i className="fal fa-chevron-left"></i>
      </span>
    )
  }
  const settings = {
    dots: true,
    arrows: false,
    infinite: false,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 2,
    arrows: false,
    appendDots: (dots) => <ul> {dots} </ul>,
    customPaging: (i) => <button>{i + 1}</button>,
    responsive: [
      {
        breakpoint: 8000,
        settings: 'unslick',
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  }
  return (
    <SbEditable content={block}>
      <section className="academy-course-block">
        <div className="academy-course-block-container">
          <div className="academy-course-block-wrapper">
            <div className="row">
              <div className="academy-course-block-header">
                <Headline
                  kicker={block.kicker}
                  headline={block.headline}
                  subheadline={block.subheadline}
                  headline_level={block.headline_level}
                />
              </div>
            </div>
            <Slider {...settings} className="academy-course-block-row">
              {block.courses?.length > 0 &&
                block.courses.map((item, index) => (
                  <div className="academy-course-block-item" key={index}>
                    <Image
                      image={item.image}
                      alt={item.alt}
                      title={item.alt}
                      imageWidth="460"
                      imageHeight="345"
                      fillColor="ffffff"
                    />
                    {item.title?.length > 0 && <h4>{item.title}</h4>}
                    {item.text?.length > 0 && <p>{item.text}</p>}
                    <Link className="btn btn-primary" link={item.link}>
                      {item.link_text}
                    </Link>
                  </div>
                ))}
            </Slider>
          </div>
        </div>
      </section>
    </SbEditable>
  )
}

export default AcademyCourseBlock
